import { ShapeMarkerEditor, IPoint, MarkerEditorProperties } from "@markerjs/markerjs3";
import DotMarker from "./DotMarker";

export default class DotMarkerEditor extends ShapeMarkerEditor<DotMarker> {
	constructor(properties: MarkerEditorProperties<DotMarker>) {
		super(properties);
	}

	protected resize(point: IPoint, preserveAspectRatio?: boolean | undefined): void {
		super.resize(point, true);
	}
}
